import { useEffect } from 'react';
import { noop } from 'lodash';
import { useUnifiedTradesService } from '#/unified-rfqs/contexts/unified-trades';

/**
 * We need to fetch trade history on start to make sure latest trades
 * are available and trade detection has the required data to run.
 */
export default function useFetchTradeHistoryOnStart() {
  const { fetcher } = useUnifiedTradesService();

  useEffect(() => {
    fetcher.fetchLatest({}, noop);
  }, [fetcher]);
}
